import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Container, Nav, Navbar, Offcanvas } from "react-bootstrap";
import logo from "../logofull.png";
import useAuthStore from "../hooks/useAuthStore";
import useCartStore from "../hooks/useCartStore";

const Header = () => {
  const expand = "lg";

  const { user } = useAuthStore();
  const isLoggedIn = !!user;
  const [isVisible, setIsVisible] = useState(true);

  const [lastScrollY, setLastScrollY] = useState(0);

   const {cartItemCount} = useCartStore();

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY > lastScrollY && currentScrollY > 100) {
        setIsVisible(false);
      } else {
        setIsVisible(true);
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [lastScrollY]);

  console.log(cartItemCount)

 


  return (
    <Navbar
      expand={expand}
      className={`main-header ${isVisible ? "visible" : "hidden"}`}
      fixed="top"
    >
      <Container>
        <Navbar.Brand as={Link} to="/">
          <img
            src={logo}
            alt="Logo"
            className="d-inline-block align-top main-logo"
          />
        </Navbar.Brand>

        <Navbar.Toggle aria-controls={`offcanvasNavbar-expand-${expand}`} />

        <Navbar.Offcanvas
          id={`offcanvasNavbar-expand-${expand}`}
          aria-labelledby={`offcanvasNavbarLabel-expand-${expand}`}
          placement="end"
        >
          <Offcanvas.Header closeButton>
            <Offcanvas.Title id={`offcanvasNavbarLabel-expand-${expand}`}>
              Navigation
            </Offcanvas.Title>
          </Offcanvas.Header>

          <Offcanvas.Body>
            <Nav className="justify-content-end flex-grow-1 align-items-lg-center">
              <Nav.Link as={Link} to="/">
                HOME
              </Nav.Link>

              <Nav.Link as={Link} to="/about-us">
                ABOUT US
              </Nav.Link>

              <Nav.Link as={Link} to="/theatres">
                THEATRES
              </Nav.Link>

              <Nav.Link as={Link} to="/contact-us">
                CONTACT US
              </Nav.Link>
              {isLoggedIn ? (
                <Nav.Link
                  as={Link}
                  to="/cart"
                  className="header-cart-link"
                  title="Cart"
                >
                  <span className="header-cart-icon">
                    <i className="fa-solid fa-cart-shopping"></i>

                    {cartItemCount > 0 && (
                      <span className="header-cart-count">{cartItemCount}</span>
                    )}
                  </span>

                
                </Nav.Link>
              ): null}
            </Nav>
          </Offcanvas.Body>
        </Navbar.Offcanvas>
      </Container>
    </Navbar>
  );
};

export default Header;
